import React from 'react';
import './Item.css';

const item = (props) => (
    
    <div className='KurzTextContainer'>
        <img 
            id={props.id}  
            className='KurzDragItem' 
            src={props.icon}
            alt={props.id}
            />
       
     
       
        <p 
            className='KurzItemText' 
            id={'text' + props.id}>

                {props.name}
        </p>
        
    </div>

)

export default item;